import React from 'react'
import { ArcherContainer } from 'react-archer'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'
import { Box } from '@material-ui/core'

import FlowchartElement from './FlowchartElement'

import useStyles from '../styles'

const FlowchartContainer = ({
  elementsByLevel,
  isFullscreenMode = false,
  flowchartRef = null,
}) => {
  const classes = useStyles()
  const isZeroLevel = (level) => level === '0'

  return (
    <PerfectScrollbar>
      <Box
        className={clsx({
          [classes.fullscreenContent]: isFullscreenMode,
          [classes.flowchartContent]: !isFullscreenMode,
        })}
        ref={flowchartRef}
      >
        <ArcherContainer
          strokeColor="red"
          svgContainerStyle={{
            zIndex: 1,
          }}
          noCurves={false}
          endMarker
        >
          {Object.keys(elementsByLevel).map((level) => (
            <Box
              key={level}
              className={clsx({
                [classes.defaultRow]: isZeroLevel(level),
                [classes.rowFlexStart]: !isZeroLevel(level),
              })}
            >
              {elementsByLevel[level].map((element) => (
                <div style={{ alignSelf: 'flex-start' }} key={element.id}>
                  <FlowchartElement element={element} />
                </div>
              ))}
            </Box>
          ))}
        </ArcherContainer>
      </Box>
    </PerfectScrollbar>
  )
}

export default FlowchartContainer
